import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'fullTextSearchPipe'
})
export class FullTextSearchPipe implements PipeTransform {
  transform(collection: any, keyword: string): any {
  	if (keyword) {
      const results = [];

      collection.forEach((item) => {
        for (const key in item) {
          if (item[key].indexOf(keyword) !== -1) {
            results.push(item);
            break;
          }
        }
      });

      return results;
    }

    return collection;
  }
}
